import { useEffect, useState } from 'react'

import { clsx } from 'clsx'

import { Time } from '../../../common/components/Time.js'
import {
  formatMessageTimestamp,
  getTimestampUpdateInterval,
} from '../../utils.js'

interface Props {
  sentAt: string
  className?: string
}

export const Timestamp = ({ sentAt, className }: Props) => {
  const [, forceUpdate] = useState({})

  // Since the timestamp is relative to the current time, we need to force an update
  // to ensure the timestamp is always up to date.
  useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate({})
    }, getTimestampUpdateInterval(sentAt))

    return () => clearInterval(interval)
  }, [sentAt])

  return (
    <Time
      className={clsx(
        'font-light text-xs text-content-muted whitespace-nowrap',
        className,
      )}
      dateTime={sentAt}
    >
      {formatMessageTimestamp(sentAt)}
    </Time>
  )
}
